/**
 * One-time-purchase pack discounts shown in the theme UI.
 * Matches Admin automatic discounts (Purchase type = One-time only):
 *   2-pack → 2% | 4-pack → 4% | 6-pack → 6%
 * Allowlisted products only — never stacked with Subscribe & Save.
 */
(function (root, factory) {
  var api = factory();
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  }
  root.JoiOtpPackDiscount = api;
})(typeof window !== 'undefined' ? window : typeof globalThis !== 'undefined' ? globalThis : this, function () {
  var BY_HANDLE = {
    'organic-hemp-base-2-pack': 2,
    'organic-peanut-base-2-pack': 2,
    'almond-base-2-pack': 2,
    'almond-base-2-pack-1': 2,
    'cashew-base-2-pack': 2,
    'cashew-base-2-pack-1': 2,
    'organic-hemp-base-4-pack': 4,
    'organic-peanut-base-4-pack': 4,
    'almond-base-4-pack': 4,
    'almond-base-4-pack-1': 4,
    'cashew-base-4-pack': 4,
    'cashew-base-4-pack-1': 4,
    'almond-base-6-pack': 6,
    'cashew-base-6-pack': 6,
    'organic-peanut-base-6-pack': 6,
    'organic-hemp-base-6-pack': 6
  };

  function normalizeHandle(handle) {
    return String(handle || '')
      .replace(/^\/products\//i, '')
      .split(/[?#]/)[0]
      .replace(/\/+$/, '')
      .toLowerCase();
  }

  var SIZE_HANDLE_INDEX = { one: 0, two: 1, four: 2, family: 3, six: 3, bulk: 4 };

  function isBulkHandle(handle) {
    var h = normalizeHandle(handle);
    if (!h) return false;
    if (h.indexOf('-pack') !== -1 && h.indexOf('bulk') === -1) return false;
    return /bulk/.test(h) || /pail/.test(h) || /-base-1(?:-|$)/.test(h);
  }

  function percentForHandle(handle) {
    var h = normalizeHandle(handle);
    if (BY_HANDLE[h]) return BY_HANDLE[h];
    // Duplicate product handles (cashew-base-2-pack-1 → cashew-base-2-pack)
    var stripped = h.replace(/-pack-\d+$/, '-pack');
    if (stripped !== h && BY_HANDLE[stripped]) return BY_HANDLE[stripped];
    return 0;
  }

  /**
   * When the selected pack tile has no product link (AJAX swap keeps the
   * original URL), infer 2/4/6 from the tile size — only after the list is
   * known to be an allowlisted family.
   */
  function percentForPackSize(size, title) {
    var s = String(size || '').toLowerCase();
    var t = String(title || '').toLowerCase();
    if (/three/.test(t) || s === 'one') return 0;
    if (s === 'two') return 2;
    if (s === 'four') return 4;
    if (s === 'bulk' || /bulk/.test(t)) return 0;
    if ((s === 'family' || s === 'six') && /six/.test(t)) return 6;
    return 0;
  }

  function handlesFromPackHandlesJson(json) {
    try {
      var raw = json;
      if (typeof raw === 'string') {
        raw = raw
          .replace(/&amp;/g, '&')
          .replace(/&quot;/g, '"')
          .replace(/&#39;/g, "'")
          .replace(/&lt;/g, '<')
          .replace(/&gt;/g, '>');
        raw = JSON.parse(raw);
      }
      if (!Array.isArray(raw) || !raw.length) return [];
      var out = [];
      var i;
      for (i = 0; i < raw.length; i++) {
        if (raw[i]) out.push(String(raw[i]));
      }
      return out;
    } catch (e) {
      return [];
    }
  }

  function handleForSizeFromPackHandles(json, size) {
    var arr = handlesFromPackHandlesJson(json);
    var s = String(size || '').toLowerCase();
    if (s === 'bulk') {
      var i;
      for (i = arr.length - 1; i >= 0; i--) {
        if (isBulkHandle(arr[i])) return normalizeHandle(arr[i]);
      }
    }
    var idx = SIZE_HANDLE_INDEX[s];
    if (idx == null || !arr[idx]) return '';
    return normalizeHandle(arr[idx]);
  }

  function familyHasOtp(handles) {
    if (!handles || !handles.length) return false;
    var i;
    for (i = 0; i < handles.length; i++) {
      if (percentForHandle(handles[i])) return true;
    }
    return false;
  }

  function percentForPackContext(handle, size, title, relatedHandles) {
    var pct = percentForHandle(handle);
    if (pct) return pct;
    if (!familyHasOtp(relatedHandles)) return 0;
    return percentForPackSize(size, title);
  }

  function applyPercent(cents, pct) {
    var n = Number(cents);
    var p = Number(pct);
    if (!n || !p) return n || 0;
    return Math.round(n * (100 - p) / 100);
  }

  function priceCentsForHandle(handle, cents) {
    return applyPercent(cents, percentForHandle(handle));
  }

  /**
   * Save % from the struck price vs the price the shopper pays.
   * Used for both one-time and Subscribe so the badge matches the two
   * amounts shown on the pack card.
   */
  function savePercent(currentCents, compareCents) {
    var current = Number(currentCents);
    var compare = Number(compareCents);
    if (!current || !compare || current >= compare) return 0;
    var pct = Math.round((1 - current / compare) * 100);
    return pct > 0 ? pct : 0;
  }

  function saveLabel(currentCents, compareCents) {
    var pct = savePercent(currentCents, compareCents);
    return pct > 0 ? 'Save ' + pct + '%' : '';
  }

  /**
   * Strikethrough cents: the higher of compare-at and the pre-discount
   * list price, but only when that amount is above what the shopper pays.
   */
  function strikeCents(currentCents, compareCents, listCents) {
    var current = Number(currentCents) || 0;
    var compare = Number(compareCents) || 0;
    var list = Number(listCents) || 0;
    var strike = compare > list ? compare : list;
    if (!strike || strike <= current) return 0;
    return strike;
  }

  function formatMoneyLike(cents, sample) {
    var n = (Math.round(Number(cents) || 0) / 100).toFixed(2);
    var s = String(sample || '').replace(/\s+/g, ' ').trim();
    if (s && /\d/.test(s)) return s.replace(/(\d+(?:,\d{3})*(?:\.\d+)?)/, n);
    return '$' + n;
  }

  return {
    BY_HANDLE: BY_HANDLE,
    normalizeHandle: normalizeHandle,
    isBulkHandle: isBulkHandle,
    percentForHandle: percentForHandle,
    percentForPackSize: percentForPackSize,
    handlesFromPackHandlesJson: handlesFromPackHandlesJson,
    handleForSizeFromPackHandles: handleForSizeFromPackHandles,
    familyHasOtp: familyHasOtp,
    percentForPackContext: percentForPackContext,
    applyPercent: applyPercent,
    priceCentsForHandle: priceCentsForHandle,
    savePercent: savePercent,
    saveLabel: saveLabel,
    strikeCents: strikeCents,
    formatMoneyLike: formatMoneyLike
  };
});
